// Styles object for use with sx prop or styled components
export const styles = {
  errorText: {
    color: 'red',
    marginTop: '20px',
  },
  chip: {
    height: '24px',
    marginLeft: '5px',
  },
  buttonLoading: {
    position: 'absolute',
    top: 'calc(50% - 15px)',
    left: 'calc(50% - 15px)',
  },
  dialogTitle: {
    fontSize: '20px',
    fontWeight: 600,
  },
  mapWrapper: {
    height: '300px',
    maxWidth: '100%',
  },
  selectBtn: {
    padding: '3px 30px 3px 10px',
    fontSize: '13px',
  },
  buttonWrapper: {
    position: 'relative',
  },
  dialogContent: {
    fontSize: '12px',
  },
  dialogAction: {
    padding: '8px 24px',
  },
  actionIcon: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  whiteBtn: {
    border: 'solid 1px #979797',
    color: '#5a5a5a',
    backgroundColor: 'white',
    textTransform: 'capitalize',
    padding: '3px 20px',
    fontWeight: 600,
    width: '120px',
  },
  confirmBtn: {
    textTransform: 'capitalize',
    padding: '4px 20px',
    fontWeight: 600,
    width: '120px',
  },
  applyBtn: {
    backgroundColor: '#8192a7',
    color: '#fff',
    textTransform: 'capitalize',
    fontSize: '10px',
    fontWeight: 600,
    marginLeft: '5px',
    border: '1px solid transparent',
  },
  undoBtn: {
    backgroundColor: '#fff',
    color: '#8192a7',
    textTransform: 'capitalize',
    fontSize: '10px',
    fontWeight: 600,
    marginLeft: '5px',
    border: '1px solid #8192a7',
  },
  rightContent: {
    paddingLeft: '20px',
  },
  smallText: {
    marginTop: '10px',
  },
  footerButton: {
    minWidth: 'auto',
    whiteSpace: 'nowrap',
    marginBottom: '4px',
    fontFamily: 'AvenirNext-Medium',
    color: '#aaaaaa',
    fontSize: '12px',
    fontWeight: 500,
    textTransform: 'none',
    paddingTop: '7px',
    paddingBottom: '7px',
    borderRadius: '3px',
    backgroundColor: 'rgb(244, 244, 244)',
  },
  freeBtnStyle: {
    minWidth: 'auto',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '4.8px',
    paddingBottom: '4.8px',
  },
  footerBtnIcon: {
    width: '16px',
    height: '15px',
    backgroundSize: 'contain',
    marginRight: '8px',
  },
  footerBtnIcon2: {
    width: '16px',
    height: '15px',
    backgroundSize: 'contain',
  },
};
